import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { deleteRequestByAuth } from "../../../../function/helper";

export default function PayLinkAgentOrdersDeleteButton({
  item,
  onSubmit,
  disabled,
  onPending,
}) {
  const { isPending, mutate } = useMutation({
    mutationKey: ["PayLinkAgentOrdersDeleteButton"],
    mutationFn: () =>
      deleteRequestByAuth("/totalpost/v1/payLink/agent/delete", {
        numberParcel: item.numberParcel,
      }).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.data.message,
            confirmButtonText: "متوجه شدم",
          });
          onSubmit();
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
      }),
  });

  const submit = () => {
    Swal.fire({
      icon: "warning",
      text: "آیا از حذف سفارش مطمئنید؟",
      confirmButtonText: "مطمئنم",
      confirmButtonColor: "blue",
      showCancelButton: true,
      cancelButtonColor: "red",
      cancelButtonText: "خیر",
    }).then(res => {
      if (res.isConfirmed) {
        onPending();
        mutate();
      }
    });
  };

  return (
    <LoadingButton
      center
      className="btn-danger text-center"
      isLoading={isPending}
      title={isPending ? "در حال حذف" : "حذف سفارش"}
      type="button"
      onClick={submit}
      disabled={disabled}
    />
  );
}
